import SwitchFieldCard from './SwitchFieldCard.vue';

export default SwitchFieldCard;